// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 684) return "static/chunks/684-2e439ad17ae0316a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1988":"b9e2e14687d66e2a","3092":"fcc769a0b254f3a6","9607":"6f0cae79a705ec6c","9611":"afda730bee6210b0"}[chunkId] + ".js";
};